import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export default function City2({ id, label, onChange, value, isInvalid }) {
  function handleChange(event) {
    let inputElement = document.getElementById(event.target.id);
    let errorElement = inputElement.nextSibling;
    if (event.target.value.trim().length === 0) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The City field should not be empty';
      errorElement.style.display = 'block';
    } else if (!/^[ a-zA-Z/-]+$/.test(event.target.value)) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The City field should contain only letters';
      errorElement.style.display = 'block';
    } else {
      errorElement.style.display = 'none';
      inputElement.classList.remove('is-invalid');
    }
    onChange(event, id);
  }
  return (
    <>
      <Form.Group as={Row} controlId={id} className="mb-3">
        <Form.Label column sm={6} required>
          {label}
        </Form.Label>

        <Form.Control
          type="text"
          placeholder={label}
          value={value ? value : ''}
          maxLength="30"
          onChange={handleChange}
          pattern="^[A-Za-z\-\/ ]+$"
          onKeyPress={(event) => {
            if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
          }}
          required
          data-hj-allow
          isInvalid={isInvalid}
        />
        <Form.Control.Feedback type="invalid">
          Please provide a city name
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
